
	import NavBar from "@/components/NavBar.vue";
	import { computed, defineComponent, ref, watchEffect } from "vue";
	import useUser from "@/store/UserState";
	import usePatientHelper from "@/store/PatientHelperState";
	import { Patient } from "@/domain/entities/Patient";
	import { onBeforeRouteLeave } from "vue-router";
	import { DateTime } from "luxon";
	import HealthIcon from "@/assets/HealthIcon.vue";
	import LungIcon from "@/assets/LungIcon.vue";
	import ThermometerIcon from "@/assets/ThermometerIcon.vue";
	/* import ThermometerFilledIcon from "@/assets/ThermometerFilledIcon.vue"; */
	import PercentageIcon from "@/assets/PercentageIcon.vue";

	function onActionClick(ev: Event): object[] {
		console.log("actionClick", ev);
		return [];
	}

	function formatRecordDateTime(datetime: Date): string {
		return DateTime.fromJSDate(datetime).toFormat("hh:mm a - dd/MM/yy");
	}

	function formatDecimalValue(value: number): number {
    return Math.ceil(value * 100) / 100; 
	}

	export default defineComponent({
		name: "Measurements",

		components: {
			NavBar,
      LungIcon,
      ThermometerIcon,
      /* ThermometerFilledIcon, */
      PercentageIcon,
      HealthIcon,
		},

		setup() {
			const { user: patient, onUserDataChange, closeUserDataChange } = useUser();
			const { listenMeasurements, measurements } = usePatientHelper();

			onUserDataChange();
			onBeforeRouteLeave(() => {
				closeUserDataChange();
			});

			let lastMeasurementRecord = computed<MeasurementRecord | undefined>(
				() => (patient.value as Patient)?.lastMeasurementRecord
			);

			// let records = watchSensorValuesFromPatient((patient as Patient).id)
			// patient.value
			watchEffect(() => {
				console.log('patient still found');
				if (patient.value != null) {
					console.log('patient found', (patient.value).id);
					listenMeasurements((patient.value).id)
				}
			});

			let indexShouldBeOpen = ref<number>(-1);
			return {
				indexShouldBeOpen,
				// latest,
				// historical,
				patient,
				onActionClick,
				lastMeasurementRecord: lastMeasurementRecord,
				records: measurements,
				formatRecordDateTime,
        formatDecimalValue,
			};
		},

		typpingOnSearch(): object[] {
			return [];
		},
	});
